
        var result = require("!!../../../../node_modules/css-loader/index.js!./quote-settings.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/quote-settings.component.css
// module id = 522
// module chunks = 0